// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3K96P","errors":"Errors_errors__1ESth"};